import * as React from 'react';
import 'fontsource-roboto';
import '../app.css';
import Button from '@material-ui/core/Button';
import {
  Box,
  Dialog, DialogActions, DialogContent, DialogTitle,
  TextField, Typography,
} from '@material-ui/core';
import type { IEmptyBagDialogProps } from './OpenerInterfaces';

const EmptyBagDialog: React.FC<IEmptyBagDialogProps> = (
  { repairId, showModal, onClose },
) => {
  const [details, setDetails] = React.useState<string>('');
  const [managerCode, setManagerCode] = React.useState<string>('');

  const handleCancel = () => {
    setDetails('');
    setManagerCode('');
    onClose(repairId);
  };

  const handleSave = () => {
    onClose(repairId, details, managerCode);
  };

  const handleDetailsChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDetails(event.target.value);
  };

  const handleManagerCodeChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setManagerCode(event.target.value);
  };

  return (
    <Dialog onClose={handleCancel} open={showModal}>
      <DialogTitle>
        <Typography variant="overline">
          {'REPAIR ID · #'}
          {repairId}
        </Typography>
        <Typography variant="h5" id="dialog-header">{'Bag does not contain repair items'}</Typography>
        <Typography variant="body2" color="textSecondary">
          {'Provide more information on shortage of repair item. Requires manager approval.'}
        </Typography>
      </DialogTitle>
      <DialogContent>
        <TextField size="small" fullWidth label="Details" variant="outlined" value={details} onChange={handleDetailsChange} />
        <Box p={1} />
        <TextField size="small" fullWidth label="Manager Code" variant="outlined" type="password" value={managerCode} onChange={handleManagerCodeChange} />
      </DialogContent>
      <DialogActions>
        <Button color="secondary" variant="text" onClick={handleCancel}>{'CANCEL'}</Button>
        <Button color="primary" variant="contained" disabled={!(managerCode && managerCode.length > 0)} onClick={handleSave}>{'SAVE UPDATES'}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmptyBagDialog;
